const defualtTheme = {
  palette: {
    primary: {
      main: '#eac13e',
    },
  },
};

export default defualtTheme;
